// Bot purpose prompts for the frontend
export const BOT_PURPOSE_PROMPTS = {
  ecommerce: {
    name: "E-commerce Assistant",
    description: "Product discovery, recommendations & shopping help",
    examples: ['Product pages', 'Categories', 'Filters', 'Outfits', 'Bundles'],
    prompt: "Crawl all product detail pages, category/listing pages, brand pages, size/color variants, price and availability. Prioritize PDPs and richly structured content (JSON-LD Product, breadcrumbs). Include sizing guides, return policies relevant to shopping. Skip non-shopping company pages."
  },
  support: {
    name: "Support Bot",
    description: "Customer support, troubleshooting & help content",
    examples: ['FAQ pages', 'Help articles', 'Troubleshooting guides', 'Contact info'],
    prompt: "Crawl all support, help, FAQ, troubleshooting, documentation, and knowledge base pages. Include contact information, support tickets, help desk articles, user guides, and any customer service related content. Skip marketing, blog posts, and news sections."
  },
  educational: {
    name: "Educational Bot",
    description: "Teaching materials, tutorials & learning resources",
    examples: ['Tutorials', 'How-to guides', 'Course materials', 'Documentation'],
    prompt: "Crawl all tutorials, guides, courses, learning resources, educational content, how-to articles, and training materials. Include documentation, walkthroughs, examples, and instructional content. Skip marketing pages, company info, and non-educational content."
  },
  sales: {
    name: "Sales Assistant",
    description: "Product info, pricing & sales materials",
    examples: ['Product features', 'Pricing pages', 'Case studies', 'Testimonials'],
    prompt: "Crawl all product pages, pricing information, features, benefits, case studies, testimonials, customer stories, and sales materials. Include product comparisons, demos, and purchase-related content. Skip technical documentation and support pages."
  },
  company: {
    name: "Company Info Bot",
    description: "About the company, team & culture",
    examples: ['About us', 'Team page', 'Company news', 'Careers'],
    prompt: "Crawl all about us pages, team information, company history, mission, vision, values, careers, job openings, press releases, and company news. Include leadership profiles and company culture content. Skip product details and technical documentation."
  },
  technical: {
    name: "Technical Docs Bot",
    description: "API docs, developer guides & technical specs",
    examples: ['API docs', 'Integration guides', 'Code examples', 'Technical specs'],
    prompt: "Crawl all API documentation, developer guides, technical specifications, code examples, integration guides, SDKs, and technical reference materials. Include architecture docs and implementation details. Skip marketing and non-technical content."
  },
  general: {
    name: "General Knowledge Bot",
    description: "All website content comprehensively",
    examples: ['All content', 'Comprehensive crawl'],
    prompt: "Crawl all pages comprehensively without filtering. Include all content types: products, services, support, documentation, company information, blog posts, and any other publicly accessible content."
  }
};